<template>
  <div class="header">
    <div class="top">
      <div class="left">
        <i class="el-icon-s-unfold" style="
            font-size: 30px;
            margin-left: 10px;
            margin-right: 20px;
            cursor: pointer;
          " @click="unfoldClick"></i>
        <!-- <div class="title">双派后台管理系统</div> -->
        <div class="title">{{ currentPageTitle  }}</div>
      </div>
      <div class="right">
        <div class="info" @click="outMet">
          <img src="@/assets/admin@2x.png" alt="">
          <div>
            <div style="font-weight: bold; font-size: 18px; margin-bottom: 4px;">{{ infoObj.realname }}</div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="bottom">
      <div class="bottom-left">
        <div v-for="(item, index) in tags" :key="index">
          <el-tag v-if="index < 13" :closable="item.name == '仪表盘' ? false : true" size="medium"
            style="margin-right: 10px; cursor: pointer" :type="layoutRouter == item.key ? 'success' : ''"
            @close="tagClose(item, index)" @click="tagClick(item)">
            {{ item.name }}
          </el-tag>
        </div>
        <div class="more" v-if="tags.length > 13">
          <el-dropdown trigger="click">
            <img class="more-imgs" src="@/assets/images/more.png" alt="" />

            <div class="more-block">
              <el-dropdown-menu slot="dropdown" style="height: 300px; overflow: auto; overflow-x: hidden">
                <el-dropdown-item v-for="(info, num) in tags.slice(13)" :key="num">
                  <el-tag size="medium" style="margin-right: 10px; cursor: pointer; width: 100%"
                    :type="layoutRouter == info.key ? 'success' : ''" @click="tagClick(info)">
                    {{ info.name }}
                  </el-tag>
                </el-dropdown-item>
              </el-dropdown-menu>
            </div>
          </el-dropdown>
        </div>
      </div>

      <div class="delete">
        <el-tag size="medium" style="margin-right: 10px; cursor: pointer" type="err" @click="deleteClose">
          一键清除
        </el-tag>
      </div>
    </div> -->

    <!-- 退出确认弹框（无需子组件，直接写在当前页面） -->
    <el-dialog title="退出确认" :visible.sync="showExitConfirm" width="400px" :close-on-click-modal="false"
      :close-on-press-escape="false" class="exit-confirm-dialog" @close="showExitConfirm = false">
      <div class="exit-confirm-content">
        <i class="el-icon-warning-outline"></i>
        <span>确定要退出当前系统吗？</span>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button size="medium" class="cancel-btn" @click="showExitConfirm = false">
          取消
        </el-button>
        <el-button size="medium" type="primary" class="confirm-btn" @click="handleExit">
          确认退出
        </el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import { mapState } from "vuex";
import { uniqueArrayOfObjects } from "@/utils/deWeight";

// import { loginOut } from "@/api/index";

export default {
  data() {
    return {
      //-------
      tags: uniqueArrayOfObjects(this.$store.state.premissions.recordRoutes),
      //---------------------------
      showExitConfirm: false
    };
  },
  computed: {
    ...mapState("premissions", ["layoutRouter", "recordRoutes", "infoObj"]),
    // 新增：获取层级式动态标题（如“电商管理-首页banner”）
    currentPageTitle() {
      // 1. 优先从路由meta中取层级标题（推荐：配置parentName+name）
      if (this.$route.meta) {
        const parentName = this.$route.meta.parentName || ""; // 父级名称（如“电商管理”）
        const currentName = this.$route.meta.name || "";     // 当前页面名称（如“首页banner”）
        // 有父级则拼接“父级-当前”，无则只显示当前
        if (parentName && currentName) {
          return `${parentName}-${currentName}`;
        } else if (currentName) {
          return currentName;
        }
      }

      // 2. 兜底：从标签列表匹配（兼容旧逻辑）
      const currentTag = this.tags.find(tag => tag.key === this.$route.name);
      if (currentTag) {
        // 若标签有parentName则拼接，无则只显示标签名
        const parentName = currentTag.parentName || "";
        const tagName = currentTag.name || "";
        return parentName ? `${parentName}-${tagName}` : tagName;
      }

      // 3. 最终兜底
      return "双派后台管理系统";
    }
  },
  watch: {
    $route(to, from) {
      this.$nextTick(() => {
        this.tags = uniqueArrayOfObjects(
          this.$store.state.premissions.recordRoutes
        );
      });
    },
  },
  created() {
    console.log(this.tags)
  },
  methods: {
    tagClose(item, index) {
      let nameKey = "";

      if (this.tags.length > 2) {
        nameKey = this.tags[index - 1].key;
      } else {
        nameKey = "instrument";
      }

      this.tags.splice(index, 1);

      if (item.key == this.$store.state.premissions.currentMenu) {
        this.$router.push({
          name: nameKey,
        });
      }

      localStorage.setItem("tabAlwaysRouter", JSON.stringify(this.tags));
    },
    tagClick(item) {
      this.$router.push({
        name: item.key,
      });
    },
    //----------
    outMet() {
      this.showExitConfirm = true
    },
    // 核心退出逻辑
    handleExit() {
      // let params = {};

      // loginOut(params).then((res) => {
      //   localStorage.clear();
      //   this.$router.go(0);
      // });

      localStorage.clear();
      this.$router.go(0);

      // 3. 关闭弹框
      this.showExitConfirm = false;

      // 4. 退出成功提示
      this.$message({
        type: 'success',
        message: '已成功退出系统，欢迎下次登录'
      });
    },
    //---------
    unfoldClick() {
      this.$store.commit(
        "premissions/COLLAPSE_IS",
        !this.$store.state.premissions.isCollapse
      );
    },
    //--------
    deleteClose() {
      let tags = [
        {
          fullPath: "/instrument",
          key: "instrument",
          name: "仪表盘",
        }
      ]
      localStorage.setItem("tabAlwaysRouter", JSON.stringify(tags));
      this.tags = tags
      this.$router.push({
        name: 'instrument',
      });
    }
  },
};
</script>


<style lang="less" scoped>
/deep/ .el-dropdown-menu__item {
  padding: 0 10px;
  width: 200px;
}

.header {
  width: 100%;
  background: #ffffff;

  .top {
    height: 70px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 30px 0 0;
    box-sizing: border-box;
    border-bottom: 1px solid #ccc;
    background: #ffffff;

    .left {
      display: flex;
      align-items: center;

      .title {
        font-size: 15px;
        font-weight: 600;
      }
    }

    .right {
      display: flex;
      align-items: center;

      .message {
        display: flex;

        .item {
          margin-right: 40px;
          cursor: pointer;
        }
      }

      .info {
        display: flex;
        align-items: center;
        cursor: pointer;

        img {
          width: 50px;
          height: 50px;
          border-radius: 50%;
          margin-right: 10px;
        }
      }

      // .title {
      //   margin-right: 40px;
      // }

      // .out {
      //   cursor: pointer;
      //   color: red;
      // }
    }
  }

  .bottom {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 10px;
    box-sizing: border-box;
    height: 50px;
    background: #4dbcff;
    border-bottom: 1px solid #ccc;

    .bottom-left {
      display: flex;
      align-items: center;

      .more {
        width: 50px;
        height: 26px;
        background: #ffffff;
        border-radius: 5px;
        border: 1px solid #ccc;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;

        .more-imgs {
          width: 16px;
          height: 16px;
        }

        .more-block {}
      }
    }



    .delete {
      height: 28px;
      display: flex;
      align-items: center;
      cursor: pointer;
    }
  }


  /*end */
  // 页面容器样式
  .layout-container {
    padding: 20px;

    .exit-btn {
      color: #f56c6c;

      &:hover {
        color: #f78989;
      }
    }
  }

  // 弹框整体样式
  .exit-confirm-dialog {
    ::v-deep .el-dialog__header {
      padding: 16px 20px;
      border-bottom: 1px solid #f0f2f5;
      text-align: center;


      .el-dialog__title {
        font-weight: bold;
        font-size: 16px;
      }
    }

    ::v-deep .el-dialog__body {
      padding: 24px 20px;
      text-align: center;
    }

    ::v-deep .el-dialog__footer {
      padding: 12px 20px 16px;
      border-top: 1px solid #f0f2f5;
      text-align: center;
    }
  }

  // 弹框内容样式
  .exit-confirm-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;

    i {
      font-size: 32px;
      color: #e6a23c;
    }

    span {
      font-size: 14px;
      color: #606266;
      line-height: 1.5;
      font-weight: bold;
    }
  }

  // 按钮样式
  .dialog-footer {
    display: flex;
    justify-content: center;
    gap: 16px;

    .cancel-btn {
      width: 100px;
      background-color: #f5f7fa;
      color: #606266;
      border: 1px solid #e5e6eb;

      &:hover {
        background-color: #e8eaed;
        border-color: #dcdfe6;
      }
    }

    .confirm-btn {
      width: 100px;
      background-color: #f56c6c;
      border-color: #f56c6c;

      &:hover {
        background-color: #f78989;
        border-color: #f78989;
      }
    }
  }

}
</style>